import React, {useMemo} from "react"
import {useTranslation} from "react-i18next"
import {KlassDropdown, KlassDropdownProps} from "../Select"
import {intersection, isEmpty, pick, size} from "lodash"
import {useAllShifts} from "hooks/useAllShifts"

type Props = Partial<KlassDropdownProps> & {campusIds?: number[]}

const ShiftSelect: React.FC<Props> = ({value, campusIds, ...props}) => {
    const {t} = useTranslation(["common"])
    const {shifts} = useAllShifts()
    const options = useMemo(() => {
        let data = shifts
        if (!isEmpty(campusIds)) {
            data = shifts.filter((item) => {
                const shiftCampusIds = item.campuses.map((campus) => campus.id)
                return size(intersection(shiftCampusIds, campusIds)) > 0
            })
        }
        return data.map((item) => pick(item, ["shiftId", "name"]))
    }, [shifts, campusIds])

    return (
        <KlassDropdown
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            value={typeof value === "number" ? options.find((option) => option.shiftId === value) : value}
            options={options}
            valueKey="shiftId"
            labelKey="name"
        />
    )
}

export default ShiftSelect
